
<section 
  class="register-user__times"
  [formGroup]="form()"
>
  <app-time-field
    [form]="form()"
    [formControlName]="formControlNameStartTime()"
  />

  <app-time-field
    [form]="form()"
    [formControlName]="formControlNameEndTime()"
  />
</section>